import { render, staticRenderFns } from "./AccessTicket.vue?vue&type=template&id=35262039&scoped=true"
import script from "./AccessTicket.vue?vue&type=script&lang=js"
export * from "./AccessTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35262039",
  null
  
)

export default component.exports